import React, { createContext } from 'react';
import { CarouselDisplayStyle } from '@honeycomb/data';
export const RootComponentContext = createContext({
    carouselDisplayStyle: CarouselDisplayStyle.Default,
    hasRepeatingBackgroundImage: false,
});
export function useRootComponent() {
    return React.useContext(RootComponentContext);
}
